<template>
  <div
    class="d-flex"
    :class="spaceBetween && 'justify-content-between'"
    @click="handleClick"
    :style="[{ alignItems: align, justifyContent: justify_content, flexDirection: flex_direction }, this.styles]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'K2Row',
  created() {},
  props: ['spaceBetween', 'align', 'justify_content', 'onclick', 'styles', 'flex_direction'],
  methods: {
    handleClick() {
      this.$emit('onclick')
    },
  },
}
</script>
<style></style>
